export class EventsInPeriodWindow {
  private _registeredEvents: number[] = [];

  public registerEvent(): void {
    this._registeredEvents.push(Date.now());
  }

  public checkEventsInPeriod(period: number): number {
    const minimalTs: number = Date.now() - period;
    this._registeredEvents = this._registeredEvents.filter((ts) => ts >= minimalTs);

    return this._registeredEvents.length;
  }

  public clear(): void {
    this._registeredEvents = [];
  }
}
